export default (date, locale = 'nl-NL', options = {}) => {
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  return new Intl.DateTimeFormat(locale, { ...defaultOptions, ...options })
    .formatToParts(new Date(date))
    .map(({ value }) => value)
    .reduce((string, part) => string + part.replace('-', '/'));
};
